"use strict";

(() => {
  window.zag = window.zag || {};

  window.zag.components.zagFooter = class extends (
    window.zag.components.ZagComponent
  ) {
    constructor() {
      super();

      this.DESKTOP_BREAKPOINT = 960;
    }

    connectedCallback() {
      this.observers.resize(this, this.onResize);
    }

    get linkDetails() {
      return this.cache.get("dom", "linkDetails", () => {
        return Array.from(this.querySelectorAll(".footer-links details"));
      });
    }

    onResize = () => {
      if (window.innerWidth >= this.DESKTOP_BREAKPOINT) {
        this.linkDetails.forEach((container) => {
          container.setAttribute("open", "");
        });
      }
    };
  };

  if (!customElements.get("zag-footer")) {
    customElements.define("zag-footer", window.zag.components.zagFooter);
  }
})();
